/// <amd-module name="Artifacts/Ivy/components/Logo" />
import * as IvyRes from "Artifacts/Ivy/Resources";
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-ivy.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={IvyRes.Logo_Ivy}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-ivy/img/ivy.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
